import { Watermark } from '@/components';
import { VITE_ENV_NAME } from '@/config';
import { t } from '@/i18n';
import { isProdOnly } from '@/utils';
import type { FC, PropsWithChildren } from 'react';
import { z } from 'zod';

const rsTargetEnvType = z.enum(['local', 'mock', 'dev', 'stg', 'preprod']);
const rsTargetEnvTypeLabelModifier = {
  local: t('target-env-local'),
  mock: t('target-env-mock'),
  dev: t('target-env-dev'),
  stg: t('target-env-stg'),
  preprod: t('target-env-preprod'),
} as const satisfies Record<z.infer<typeof rsTargetEnvType>, string>;

export const TargetEnvIndicator: FC<PropsWithChildren> = ({ children }) => {
  // isProdOnly はあまり使いたくないが、Watermark で環境を区別するためだけであれば、許容する
  return !isProdOnly() ? (
    <Watermark
      content={
        rsTargetEnvTypeLabelModifier[VITE_ENV_NAME] ?? t('target-env-local')
      }
      gap={[5, 10]}
      font={{ color: 'rgba(255, 0, 0, 0.25)' }}
    >
      {children}
    </Watermark>
  ) : (
    children
  );
};
